export const tokenManager = {
    getToken() {
        return process.env.REACT_APP_MONITOR_TOKEN;
    },

    hasToken() {
        return !!this.getToken();
    },

    getAuthHeaders() {
        const token = this.getToken();
        return token 
            ? { Authorization: `Bearer ${token}` }
            : {};
    }
};